// @ts-check

export const introTargets = {
	navMediumButton: 'NavMediumButton',
	navHomeSection: 'NavHomeSection',
	navProjectsSection: 'NavProjectsSection',
	navServersSections: 'NavServersSections',
	navAccountBalance: 'NavAccountBalance',
	navDesktopCreateAndDeploy: 'NavDesktopCreateAndDeploy',
	navHelpMenu: 'NavHelpMenu',
	navAccountMenu: 'NavAccountMenu',
	serverInteriorSettingsTab: 'ServerInteriorSettingsTab',
	serverInteriorSettingsSubNav: 'ServerInteriorSettingsSubNav',
};

/**
 * @typedef {typeof introTargets[keyof typeof introTargets]} IntroTargetT
 */

/**
 * @typedef IntroConfigStepI
 * @prop {Element} [element]
 * @prop {string} [elementTarget] Element key defined by useIntroTarget
 * @prop {string} [title]
 * @prop {string} [intro]
 * @prop {boolean} [allowInvisible]
 * @prop {import('intro.js/src/core/steps').TooltipPosition} [position]
 * @prop {'off' | undefined} [scrollTo]
 */

/** @typedef {Partial<import('intro.js/src/option').Options>} IntroJsOptions */

/**
 * @typedef IntroTourConfigI
 * @prop {boolean} shouldPause If true, the tour will be paused until a later date if not completed. If false, the tour will be marked complete whenever the user exits the tour, even if it is not completed.
 * @prop {boolean} [disabled] If true, the tour will not be shown.
 * @prop {IntroConfigStepI[]} steps
 * @prop {IntroJsOptions} [introJsOptions] see https://introjs.com/docs/tour/options
 */

/** @type {Record<string, IntroTourConfigI>} */
export const tourConfigs = {
	navcollapsed354: {
		shouldPause: true,
		disabled: true,
		steps: [
			{
				elementTarget: introTargets.navMediumButton,
				title: 'Navigation',
				intro: 'Access the collapsed main navigation via the menu button',
				position: 'right',
			},
		],
	},
	navmain354: {
		shouldPause: true,
		disabled: true,
		steps: [
			{
				elementTarget: introTargets.navHomeSection,
				title: 'Your Liquid Web',
				intro:
					'Explore services and save favorite portal sections for quick access',
				position: 'right',
			},
			{
				elementTarget: introTargets.navProjectsSection,
				title: 'Projects',
				intro: 'Organize hosting services into easy-to-manage projects',
				position: 'right',
			},
			{
				elementTarget: introTargets.navServersSections,
				title: 'Your Servers',
				intro: 'View and manage your servers in one place',
				position: 'right',
			},
			{
				elementTarget: introTargets.navAccountBalance,
				title: 'Account Balance',
				intro: 'Check and manage your account balance',
				position: 'right',
				scrollTo: 'off',
			},
			{
				elementTarget: introTargets.navDesktopCreateAndDeploy,
				title: 'Grow your hosting',
				intro: 'Easily create and deploy new hosting services',
				position: 'bottom',
			},
			{
				elementTarget: introTargets.navHelpMenu,
				title: 'Help',
				intro: 'Access Help Docs, common issues, and Support chat',
				position: 'bottom',
			},
			{
				elementTarget: introTargets.navAccountMenu,
				title: 'Account',
				intro: 'Manage secure notes, your account, and user settings',
				position: 'bottom',
			},
		],
	},
	serverInteriorSettingsTab: {
		shouldPause: false,
		steps: [
			{
				elementTarget: introTargets.serverInteriorSettingsTab,
				title: 'Settings',
				intro:
					"We've introduced a streamlined section for monitored services, add-ons, and server options.",
				position: 'top',
			},
		],
		introJsOptions: {
			showButtons: false,
			showBullets: false,
		},
	},
	serverInteriorSettingsSubNav: {
		shouldPause: false,
		steps: [
			{
				elementTarget: introTargets.serverInteriorSettingsSubNav,
				title: 'Personalization',
				intro:
					'Name your server, upgrade with powerful add-ons, and customize your monitored services.',
				position: 'bottom',
			},
		],
		introJsOptions: {
			showButtons: false,
			showBullets: false,
		},
	},
};

export default tourConfigs;
